// @flow
/* Just a wrapper around ClickTracker, no need for tests/story. */
/* eslint-disable ta-code-conventions/has-matching-storydoc */
/* eslint-disable ta-code-conventions/has-matching-test */
import * as React from 'react';
import { connect } from 'react-redux';
import { ClickTracker } from '@ta/common.tracking';

/**
 * This is a fancy wrapper around ClickTracker geared toward sharing content
 * We want to ensure tracking between various sharing flows is consistent, so we need to have a common tracking component.
 *
 * */
type ShareAction = 'share_button_click' | 'share_select' | 'share_modal_open';

type ShareType = 'sms' | 'email' | 'clipboard' | 'repost_action';

type ExternalProps = {|
  /** The URL to share */
  url: string,

  /** The type of item we are sharing */
  itemType: string,

  /** The ID of the item? e.g. if it is a POI, what is the locationID */
  itemId: string,

  /** The share button action type */
  action: ShareAction,

  /** The means in which we are sharing the item */
  type: ?ShareType,

  /** Render prop that passes in a url to use for tracking */
  children: string => React.Node,
|};

type Props = {|
  ...ExternalProps,
|};

const MCID: { [ShareType]: number } = { sms: 19907, email: 55593, clipboard: 19905 };

const ShareTracker = ({ url, itemType, itemId, action, type, children }: Props) => {
  const addMcidToUrl = (mcid: number): string => {
    if (itemType === 'LinkPost') {
      return url;
    }
    const hasQuery = url.indexOf('?') !== -1;
    const hasHash = url.indexOf('#') !== -1;
    const appendix = `${hasQuery ? '&' : '?'}m=${mcid}`;
    return hasHash ? url.replace('#', `${appendix}#`) : `${url}${appendix}`;
  };

  const trackingModule = 'ShareCta';
  const trackingContext = `${itemType}|${itemId}|${url}`;
  return (
    <ClickTracker
      useSpan
      module={trackingModule}
      action={action}
      context={trackingContext}
      once={false}
      value={type && type !== 'repost_action' ? MCID[type] : undefined}
    >
      {type && type !== 'repost_action' ? children(addMcidToUrl(MCID[type])) : children(url)}
    </ClickTracker>
  );
};

ShareTracker.defaultProps = { type: null };

export default connect<Props, ExternalProps, _, _, _, _>((redux, externalProps) => ({
  url: externalProps.url.startsWith('/')
    ? redux.meta.baseUrl + externalProps.url
    : externalProps.url,
}))(ShareTracker);
